import { OnTooltipEvent } from './tooltip.types'

export const TOOLTIP_EVENT = 'TOOLTIP_EVENT'

export const onTooltipEvent: OnTooltipEvent = payload => ({
  payload,
  type: TOOLTIP_EVENT
})
